export default __webpack_public_path__ + "static/5-e7258fbe189dff84846035f180afa3dc.webp";